// extracted by mini-css-extract-plugin
module.exports = {"cancel__text":"CashierTicket_cancel__text__S4sTN","receipt__number":"CashierTicket_receipt__number__3A16K"};